import { Injectable } from "@angular/core";
import { Observable, of as observableOf } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { CustomerModel } from "../../shared/entities/customer.model";
import { CustomerModelLite } from "../../shared/entities/customer-lite.model";
import { UserModelService } from "../services/user/user-model.service";

@Injectable()
export class CustomerModelRepository {
	constructor(private user_model_service: UserModelService) {}

	public createNewCustomerModel(customer?: CustomerModel): Observable<any> {
		return this.user_model_service.postCustomerModel(customer!).pipe(
			map((data: any) => {
				return data;
			}),
			catchError((err) => {
				return observableOf(err);
			}),
		);
	}

	public createCustomerModelLite(customer: CustomerModelLite) {
		return this.user_model_service.postCustomerModelLite(customer).pipe(
			map((data: any) => {
				return data;
			}),
			catchError((err) => {
				return observableOf(err);
			}),
		);
	}

	public getAdminCustomerById(id?: string): Observable<CustomerModel> {
		return this.user_model_service.getCustomerModelById(id!).pipe(
			map((data: any) => {
				return data;
			}),
			catchError((err) => {
				return observableOf(err);
			}),
		);
	}

	public updateAdminCustomerById(id?: string, customer?: any): Observable<any> {
		return this.user_model_service.updateCustomerModelById(id!, customer).pipe(
			map((data: any) => {
				return data;
			}),
			catchError((err) => {
				return observableOf(err);
			}),
		);
	}

	public getAdminCustomers(): Observable<any> {
		return this.user_model_service.getCustomersModels().pipe(
			map((data: any) => {
				return data;
			}),
			catchError((err) => {
				return observableOf(err);
			}),
		);
	}

	public deleteAdminCustomers(id: string): Observable<any> {
		return this.user_model_service.deleteCustomerModelById(id).pipe(
			map((data: any) => {
				return data;
			}),
			catchError((err) => {
				return observableOf(err);
			}),
		);
	}

	public resendEmail(_id: string): Observable<unknown> {
		return this.user_model_service.resendEmail(_id);
	}
}
